(function(){
    const stalkTriggers = document.querySelectorAll('[data-boutique-list-item-trigger]');


    if(stalkTriggers && stalkTriggers.length) {
        const stalkingImages = [];
        stalkTriggers.forEach(function(trigger){
            const targetImage = trigger.querySelector('[data-boutique-list-item]');
            let lastMouse = { x: null, y: null };
            const minDist = 15;

            if(!trigger || !targetImage) return;

            const targetImageDisplay = window.getComputedStyle(targetImage).display;
            if(targetImageDisplay === 'none') return;
                trigger.addEventListener('mousemove', debounce(function(e) {

                    if(!targetImage) return;

                    const rect = trigger.getBoundingClientRect();
                    const mouseX = e.clientX - rect.left;
                    const mouseY = e.clientY - rect.top;
                    const percentX = mouseX / rect.width;
                    const percentY = mouseY / rect.height;

                    if (lastMouse.x !== null && lastMouse.y !== null) {
                        const delta = Math.hypot(mouseX - lastMouse.x, mouseY - lastMouse.y);

                        // Saving last mouse position
                        lastMouse.x = mouseX;
                        lastMouse.y = mouseY;

                        if (delta < minDist) return; // Too small, ignore
                    }

                    // Saving last mouse position
                    lastMouse.x = mouseX;
                    lastMouse.y = mouseY;

                    if (targetImage.gsapTween) targetImage.gsapTween.kill();

                    const movementRangeX = 100;
                    const movementRangeY = 100;

                    const maxRotation = 25; // Overshoot amount
                    const startRotation = (percentX - 0.5) * maxRotation;

                    const translateX = (percentX - 0.5) * movementRangeX;
                    const translateY = ((percentY - 0.5) * movementRangeY);

                    targetImage.gsapTween = gsap.to(targetImage, {
                        x: translateX,
                        y: translateY,
                        ease: "power3.Out",
                        duration: 1.5,
                        onUpdate: function() {
                        let p = this.progress();
                        let eased = 1 - p;

                        gsap.to(targetImage, {
                            rotate: startRotation * eased,
                            ease: "power3.Out",
                            duration: .35,
                        });
                    },
                    onStart: function() {
                        gsap.to(targetImage, {
                            rotate: startRotation,
                            ease: "power3.Out",
                            duration: .35,
                        });
                    },
                    onComplete: function() {
                        gsap.to(targetImage, {
                            rotate: 0,
                            ease: "power3.Out",
                            duration: .35,
                        });
                    }
                    });
            }, 5));
        });
    }
})();